import React, { Component } from 'react';
import './Welcome.css';

class Welcome extends Component {
  render() {
    return (
      <div className="col-12 welcome">
        <a href="#contact" className="contact">contact</a>
        <h1>talk less<br/>do more</h1>
        <h2>Max Stralka combines software engineering, design skills and team mentoring on a unique level.</h2> 
      </div>
    );
  }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/welcome/Welcome.js